import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex min-h-screen bg-gray-50" }
const _hoisted_2 = { class: "w-64 bg-white border-r border-gray-200 flex flex-col flex-shrink-0" }
const _hoisted_3 = { class: "flex items-center px-6 py-5 border-b border-gray-200" }
const _hoisted_4 = { class: "flex-1 px-3 py-4 space-y-1" }
const _hoisted_5 = { class: "px-4 py-4 border-t border-gray-200" }
const _hoisted_6 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_7 = { class: "text-sm font-semibold text-gray-800 truncate" }
const _hoisted_8 = { class: "text-xs text-gray-400 truncate" }
const _hoisted_9 = { class: "flex-1 overflow-y-auto overflow-x-auto" }
const _hoisted_10 = { class: "max-w-2xl min-w-[28rem] px-8 py-10" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-center py-24"
}

import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { User, ShieldCheck, Bell, LogOut } from 'lucide-vue-next';
import { useStore } from '@/plugins/store';
import { ActionType } from '@/plugins/store/actions';
import Authentication from '@/plugins/authentication';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountLayout',
  setup(__props) {

const store = useStore();
const route = useRoute();
const { t } = useI18n();

const booting = ref(!store.state.user || !store.state.languages.length);
const user = computed(() => store.state.user);

const logoSrc = `${process.env.BASE_URL}solutions/${process.env.VUE_APP_SOLUTION_PATH}/assets/images/sidebar-logo.svg`;

const navItems = computed(() => [
    { to: '/account/profile', label: t('nav.profile'), icon: User },
    { to: '/account/security', label: t('nav.security'), icon: ShieldCheck },
    // { to: '/account/notifications', label: t('nav.notifications'), icon: Bell }, // TODO: enable when notifications API is supported
]);

function isActive(path: string) {
    return route.path.startsWith(path);
}

function onLogoError(e: Event) {
    (e.target as HTMLImageElement).style.display = 'none';
}

async function logout() {
    await Authentication.logout();
}

onMounted(async () => {
    try {
        await Promise.all([
            store.state.user ? Promise.resolve() : store.dispatch(ActionType.FetchProfile),
            store.state.languages.length ? Promise.resolve() : store.dispatch(ActionType.FetchLanguages),
        ]);
    } catch {
        // Non-fatal — page still renders
    } finally {
        booting.value = false;
    }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: logoSrc,
          alt: "Logo",
          class: "h-16 w-full object-contain object-left",
          onError: onLogoError
        }, null, 32)
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems.value, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.to,
            to: item.to,
            class: _normalizeClass(["flex items-center gap-3 px-3 py-2.5 rounded-lg text-normal font-medium transition-colors duration-150", isActive(item.to)
                        ? 'bg-primary-500 bg-opacity-30 text-primary-800'
                        : 'text-gray-600 hover:bg-gray-100'])
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                size: 32,
                class: "flex-shrink-0"
              })),
              _createTextVNode(" " + _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (user.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(user.value.firstName) + " " + _toDisplayString(user.value.lastName), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(user.value.email), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors",
          onClick: logout
        }, [
          _createVNode(_unref(LogOut), { class: "w-4 h-4" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.signOut')), 1)
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (booting.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "w-8 h-8 rounded-full border-2 border-gray-200 border-t-primary-500 animate-spin" }, null, -1)
            ]))]))
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ])
    ])
  ]))
}
}

})